import getLoader from 'prismjs/dependencies';
import components from 'prismjs/components';

const supportedLanguages = [
    // defaults
    // 'none', 'markup', 'xml', 'html', 'mathml', 'svg', 'css', 'clike', 'javascript', 'js',

    // デフォルトに含まれないけどロードしておかないと PHP 等のシンタックスでエラーになる
    'markup-templating',

    'bash', 'c', 'csharp', 'cpp', 'diff', 'erlang',
    'glsl', 'groovy', 'go', 'haskell', 'java', 'json', 'julia',
    'kotlin', 'latex', 'lua', 'makefile', 'matlab', 'objectivec', 'ocaml',
    'pascal', 'perl', 'php', 'python', 'r', 'ruby', 'rust',
    'sas', 'scala', 'scheme', 'sql', 'swift', 'yaml',

    // マイナー汎用
    'd', 'dart', 'elixir', 'nim',

    // 古典
    // 'ada', 'basic', 'eiffel', 'fortran', 'prolog', 'smalltalk', 'tcl',

    // MSシェルどうしたものか
    // 'batch', 'powershell',

    // 設定ファイル案外使う
    'ini', 'properties',

    // OCamlでいいか
    // 'fsharp'

    // Alt-JS/CSS
    'coffeescript', 'jsx', 'less', 'sass', 'scss', 'stylus', 'typescript',

    // HTMLテンプレート言語
    'haml', 'pug',
    // HTMLに埋めるテキストテンプレートだしいいか
    // 'django', 'smarty', 'twig',

    // マークアップ
    'markdown', 'rest',
    // 方言きついし用途なさそう
    // 'wiki' ,'textile',

    // 特殊
    // 'docker', 'gherkin', 'protobuf', 'vim',
].concat(Object.keys(Prism.languages)); // デフォルトで存在する js や html, css などをカバー

$.fn.prism = function(options) {
    options = $.extend({
        theme: '',
    }, options);

    const $root = this;

    const languages = detectLanguages();
    loadPrism(languages).then(() => {
        // console.log('Prism loaded and highlighted all languages:', languages);
    }).catch((error) => {
        console.error('Error loading Prism languages:', error);
    });

    function detectLanguages() {
        const detected = [];
        $root.find('pre code').each((i, el) => {
            const $el = $(el);
            const lang = $el.attr('class') || '';
            const match = lang.match(/language-(\w+)/);
            if (match && match[1] && detected.indexOf(match[1]) === -1) {
                detected.push(match[1]);
            }
        });
        return detected;
    }

    async function loadPrism(languages) {
        // テーマの動的ロード
        if (!window._prismThemeLoaded) {
            if (options.theme === 'dark') {
                await import('prismjs/themes/prism-dark.css');
            } else {
                await import('prismjs/themes/prism.css');
            }
            window._prismThemeLoaded = true;
        }

        const componentsToLoad = languages.filter(lang => supportedLanguages.includes(lang));
        const loadedComponents = Object.keys(Prism.languages);

        const loader = getLoader(components, componentsToLoad, loadedComponents);

        const importPromises = [];
        loader.load((lang) => {
            const importPromise = import(/* webpackChunkName: "prismjs/prism-" */`prismjs/components/prism-${lang}.js`).then(() => {
                // console.log(`Loaded Prism component for language: ${lang}`);
            }).catch((error) => {
                console.error(`Error loading Prism component for language: ${lang}`, error);
            });
            importPromises.push(importPromise);
        });
        await Promise.all(importPromises);

        for (const el of $root) {
            Prism.highlightAllUnder(el);
            // console.log(`Prism highlighted all under element:`, el);
        }
    }
};
